/* @generated */
import * as React from "react";
import { EXTENSIONS_MAP } from "./extensions.esm.js";
const useFindContentIcon = ({ extension, size }) => {
  const Icon = React.useMemo(() => {
    let type = `${extension}-${size}`;
    if (!EXTENSIONS_MAP[type]) {
      type = `unknown-${size}`;
    }
    return EXTENSIONS_MAP[type];
  }, [extension, size]);
  return Icon;
};
export {
  useFindContentIcon
};
